import React, { useState } from "react";

import DstButton from "../../../../components/DstButton/DstButton";
import Popup from "../../../../components/Popup/Popup";
import translate from "../../../../services/Translate";
import { JobBlockTag } from "../../LandingPageJobBlocks.d";
import { createJobBlock } from "../../LandingPageJobBlocks.function";
import JobBlockFormFields from "../JobBlockFormFields/JobBlockFormFields";
import { AddCardJobBlockProps } from "./AddCardJobBlock.d";

const AddCardJobBlock = ({ show, onClose, onCreated, language }: AddCardJobBlockProps) => {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [link, setLink] = useState("");
  const [question, setQuestion] = useState("");
  const [resume, setResume] = useState("");
  const [tags, setTags] = useState<JobBlockTag[]>([]);
  const [subCategory, setSubCategory] = useState("");

  const _isFormValid =
    [title, category, link, question, resume].every((field) => field.trim()) && tags.every((tag) => tag.text?.trim());

  const _resetForm = () => {
    setTitle("");
    setCategory("");
    setLink("");
    setQuestion("");
    setResume("");
    setTags([]);
    setSubCategory("");
  };

  return (
    <Popup
      show={show}
      onClose={() => {
        onClose();
        _resetForm();
      }}
      modalTitle={translate(language, "PAGES.LANDING_PAGE_JOB_BLOCKS.ADD_CARD.TITLE")}
      size="lg"
    >
      <div className="d-flex flex-column gap-3">
        <JobBlockFormFields
          title={title}
          setTitle={setTitle}
          category={category}
          setCategory={setCategory}
          link={link}
          setLink={setLink}
          question={question}
          setQuestion={setQuestion}
          resume={resume}
          setResume={setResume}
          tags={tags}
          setTags={setTags}
          language={language}
          setSubCategory={setSubCategory}
          subCategory={subCategory}
        />

        {!_isFormValid && (
          <small className="text-muted">
            {translate(language, "PAGES.LANDING_PAGE_JOB_BLOCKS.ADD_CARD.ERRORS.REQUIRED_FIELDS")}
          </small>
        )}

        <div className="d-flex gap-2 justify-content-end mt-3">
          <DstButton
            value={translate(language, "GLOBAL.CANCEL")}
            variant="secondary"
            clickFunction={() => {
              onClose();
              _resetForm();
            }}
          />

          <DstButton
            value={translate(language, "GLOBAL.CREATE")}
            clickFunction={() =>
              createJobBlock(
                {
                  title: title.trim(),
                  category: category.trim(),
                  link: link.trim(),
                  question: question.trim(),
                  resume: resume.trim(),
                  tags,
                  subcategory: subCategory.trim(),
                },
                language,
                () => {
                  onCreated();
                  onClose();
                  _resetForm();
                }
              )
            }
            disabled={!_isFormValid}
          />
        </div>
      </div>
    </Popup>
  );
};

export default AddCardJobBlock;
